module.exports = __webpack_public_path__ + "static/media/manipur.b94e19fd.png";